import { Box } from '@mui/material'
import Sidebar from '../../components/sidebar/sidebar.component'
import Topbar from '../../components/topbar/topbar.component'
import { Outlet, useLocation } from 'react-router-dom'
import { SIDEBAR_WIDTH } from '../../components/sidebar/sidebar.styles'
import { AuthFeaturesSync } from './auth-features-sync'
import { AuthUserSync } from './auth-user-sync'

/** Must match `topbar.styles` Paper height so the shell never exceeds the viewport. */
const MAIN_MAX_HEIGHT = 'calc(100dvh - 50px)'

/** Viewport column below the header; children fill with flex + minHeight:0 (scroll inside panels). */
const ThreeColLayout = () => {
  const { pathname } = useLocation()
  const pageKey = pathname.split('/').filter(Boolean)[0] ?? 'root'

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100dvh',
        width: '100%',
        bgcolor: 'background.default',
      }}
    >
      <Topbar />
      <AuthUserSync />
      <AuthFeaturesSync />
      <Box
        component="main"
        sx={{
          display: 'flex',
          flex: 1,
          minHeight: 0,
          maxHeight: MAIN_MAX_HEIGHT,
          width: '100%',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            display: { xs: 'none', lg: 'flex' },
            width: SIDEBAR_WIDTH,
            flexShrink: 0,
            flexDirection: 'column',
            alignSelf: 'stretch',
            minHeight: 0,
            maxHeight: MAIN_MAX_HEIGHT,
            overflow: 'hidden',
          }}
        >
          <Sidebar />
        </Box>
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            py: { xs: 1, lg: 0 },
            px: { xs: 1, lg: 0 },
          }}
        >
          <Outlet key={pageKey} />
        </Box>
      </Box>
    </Box>
  )
}

export default ThreeColLayout
